export default __webpack_public_path__ + "static/media/next-arrow.174f55fd.svg";